/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { fetchOptinAvailability } from 'ui-addon-opt/api/OptinsAPI';
import { OPTIN_VIEW_NEW, OPTIN_VIEW_CURRENT } from 'ui-addon-opt/constants/UIOptConstants';
import { OPT_STATE_OPTED_IN } from './OptState';
export const toOptinView = availability => availability.state === OPT_STATE_OPTED_IN ? OPTIN_VIEW_NEW : OPTIN_VIEW_CURRENT;
export const getInitialOptinView = optinName => fetchOptinAvailability(optinName).then(({
  optinView
}) => optinView);